import { Skeleton as MuiSkeleton } from '@mui/material';
import type { SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton';

export type SkeletonProps = MuiSkeletonProps;

export const Skeleton = ({ animation = 'wave', ...rest }: SkeletonProps): JSX.Element => (
  <MuiSkeleton animation={animation} {...rest} />
);
